<template>
  <div class="container">
    <div class="cashapp-container">
      <img src="@/assets/img_pay_title.png" class="apple-title" alt="apple pay">
      
      <div class="apple-pay-desc">
        <h2>Secure Payment via Apple Pay</h2>
        <p>This order is securely using Apple Pay. All transactions are protected by Apple's security measures. Your payment details are encrypted and kept safe. Review and confirm below.</p>
      </div>
    </div>

    <div class="amount-container">
      <div class="order-details">
        <div class="amount-row">
          <span class="label">Amount:</span>
          <span class="value">$ {{ (amount/100).toFixed(2) }} </span>
        </div>
        <div class="divider"></div>
        <div class="order-row">
          <span class="label">Order Id:</span>
          <span class="id">{{ orderId }}</span>
        </div>
      </div>
    </div>

    <div id="component-container" class="payment"></div>

  </div>
</template>

<script>
import apiClient,  {API_URL_CREATE_ORDER,API_URL_AD_QUERY_ORDER,API_URL_CREATE_PAYMENT}  from '@/services/api'; // 引入封装好的 HTTP 请求
import { AdyenCheckout, ApplePay } from '@adyen/adyen-web';
import '@adyen/adyen-web/styles/adyen.css';

export default {
  data() {
    return {
      stripe: null,
      clientSecret: null,
      elements: null,
      amount: null,  // 从 URL 查询参数中获取传入的 amount
      encryptedString: this.$route.params.encryptedString,  // 从 URL 获取加密串
      orderId: null, // 从 URL 查询参数中获取传入的 orderId
      payType: null,
      errorMsg: null,
      returnUrl: null,
      wayCode: null,
      platformWebsite: null,
      randomNo: null
    };
  },
  async mounted() {
    document.title = 'Payment Center';
    try {
      const response = await apiClient.post(API_URL_CREATE_PAYMENT, {
        encryptedString: this.encryptedString
      });
      //this.clientSecret = response.data.clientSecret;
      this.amount = response.data.amount;
      this.orderId = response.data.orderId;
      this.wayCode = response.data.wayCode;
      this.platformWebsite = response.data.platformWebsite;
      this.payType = response.data.payType;
      this.errorMsg = response.data.errorMsg;
      this.returnUrl = response.data.returnUrl;
      this.clientKey = response.data.clientKey;
      this.sessionData = response.data.sessionData;
      this.sessionId = response.data.sessionId;
      this.environment = response.data.environment;
      this.randomNo = Math.random().toString(36).slice(-8);

      const globalConfiguration = {
        session: {
          id: this.sessionId, // Unique identifier for the payment session.
          sessionData: this.sessionData // The payment session data.
        },
        environment: this.environment, // Change to 'live' for the live environment.
        amount: {
          value: this.amount,
          currency: 'USD'
        },
        locale: 'en-US',
        countryCode: 'US',
        clientKey: this.clientKey, // Public key used for client-side authentication: https://docs.adyen.com/development-resources/client-side-authentication
        onPaymentCompleted: (result, component) => {
          console.info('onPaymentCompleted----');
          console.info(result, component);
          if(result.resultCode === 'Authorised'){
            window.location = 'https://www.focusshortvip.com/payresult.php?status=SUCCESS';
          }else {
            window.location = 'https://www.focusshortvip.com/payresult.php?status='+result.resultCode;
          }
        },
        onPaymentFailed: (result, component) => {
          console.info('onPaymentFailed----');
          console.info(result, component);
          if(result.resultCode === 'Authorised'){
            window.location = 'https://www.focusshortvip.com/payresult.php?status=FAIL';
          }
        },
        onError: (error, component) => {
          console.error(error.name, error.message, error.stack, component);
          //alert(error.name);
          //alert(error.message);
          //alert(error.stack);
          window.location = 'https://www.focusshortvip.com/payresult.php?status=FAIL';
        }
      };
      const checkout = await AdyenCheckout(globalConfiguration);
      const dropin = new ApplePay(checkout, globalConfiguration).mount('#component-container');

      console.log('dropin', dropin);

    } catch (error) {
      console.error('error', error);
    }
  },
  methods: {
    async handleCashappPaymentAuto() {

    },
    async orderQuery() {
      const response = await apiClient.post(API_URL_AD_QUERY_ORDER, {
        orderId: this.orderId
      });
      this.state = response.data.state;
      if(this.state === 2){
        window.location = 'https://www.focusshortvip.com/success.html';
      }
    },
    async handleCashappPayment() {

    },
    async handlePayment() {

    },
    async sendOrderInfo(orderId,submitType,errMsg) {
      try {
        apiClient.post(API_URL_CREATE_ORDER, {
          userAgent: navigator.userAgent,
          orderId: orderId,
          submitType: submitType,
          errMsg: errMsg
        });
      } catch (error) {
        console.error('error:', error);
      }
    },
    async disabledButton() {
      try {
        var payNowButton = document.getElementById('PayNow');
        payNowButton.textContent = 'Please wait.payment processing...';
        payNowButton.disabled = true;
        document.getElementById('ortest').innerHTML = 'If you have not completed the payment and wish to continue using <strong>cashapp</strong> payment, please refresh this page!'; 
      } catch (error) {
        console.error('pay failed:', error);
        document.getElementById('error-message').textContent = error;
        this.sendOrderInfo(this.orderId,this.randomNo + ' disabledButton error',error);
      }
    },
    async enabledButton() {
      try {
        var payNowButton = document.getElementById('PayNow');
        var i = 3;
        var interval = setInterval(function() {
          if(i>0){
          payNowButton.textContent = 'The order is being pulled up, you can click on payment again in '+i+' seconds';
          i--;
          }else{
            payNowButton.textContent = 'Cash APP Pay';
            clearInterval(interval);
          }
        }, 1000);
        payNowButton.disabled = false;
        document.getElementById('ortest').innerHTML = ''; 
      } catch (error) {
        console.error('pay failed:', error);
      }
    },
  },
};
</script>
<style scoped>
/* 新增外层容器 */
  .container {
    /*margin-top:100px;*/
    max-width: 100%;
    min-height: 100vh;
    background-color: #0000;
  }

  .cashapp-container {
    max-width: 400px;
    margin: 20px auto 0px auto;
    padding: 30px 25px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  }

  .amount-container {
    max-width: 450px;
    margin: 0 auto;
    padding: 0px 0px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  }


  /* 按钮样式 */
  .apple-pay-btn {
    max-width: 450px;
    margin:20px auto;
    padding: 0px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 56px;
    /*background: #0A0A0A;*/
    border-radius: 8px;
    cursor: pointer;
    transition: opacity 0.2s;
  }
  .apple-pay-btn:hover {
    opacity: 0.9;
  }

  /* 居中文字 */
  .apple-pay-desc {
    text-align: center;
  }
  .apple-pay-desc h2 {
    font-size: 18px;
    margin: 0 0 12px 0;
    color: #0A0A0A;
  }
  .apple-pay-desc p {
    color: #666;
    line-height: 1.5;
    margin: 8px 0;
    font-size: 14px;
    color: #929292;
  }


  /* 订单信息样式 */
  .order-details {
    background: #fff;
    border-radius: 8px;
    margin:7px 0;
    color: #929292;
    padding: 13px 0px;
  }

  .amount-row, .order-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 3px 15px;
  }

  .label {
    color: #929292;
    font-size: 16px;
  }

  .value {
    color: #0A0A0A;
    font-weight: 600;
    font-size: 18px;
    padding: 0px 5px;
  }

  .id {
    color: #929292;
    font-size: 14px;
    padding: 0px 5px;
  }

  .divider {
    height: 1px;
    background-color: #eee;
    margin: 12px 0;
  }

  .apple-logo {
    width: auto;
    height: 24px;
  }

  /* 标题图片 */
  .apple-title {
    display: block;
    margin: 0 auto 20px;
    width: 120px;
  }
</style>